import { ProMailboxStatus } from '../email_hosting';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_PRO_MAILBOX_STATUS = 'PRO_MAILBOX_STATUS_';

export const ProMailboxStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRO_MAILBOX_STATUS}${ProMailboxStatus.PENDING}`]: 'En attente',
    [`${TRANSLATE_KEY_PRO_MAILBOX_STATUS}${ProMailboxStatus.PROVISIONING}`]: 'Création en cours',
    [`${TRANSLATE_KEY_PRO_MAILBOX_STATUS}${ProMailboxStatus.ACTIVE}`]: 'Active',
    [`${TRANSLATE_KEY_PRO_MAILBOX_STATUS}${ProMailboxStatus.ERROR}`]: 'Erreur',
    [`${TRANSLATE_KEY_PRO_MAILBOX_STATUS}${ProMailboxStatus.SUSPENDED}`]: 'Suspendue',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(ProMailboxStatus, ProMailboxStatusTranslation, TRANSLATE_KEY_PRO_MAILBOX_STATUS, true);
